<div class="sh-sticky-header -sh-overlay" *ngIf="!(loading$ | async) && availableSelect && selectedItemsCount">
    <sh-context-action-bar
        id="context-bar"
        [actionGroup]="contextActionGroup"
        [canBatchSelect]="canBatchSelect"
        [itemsSelectedLabelKey]="itemsSelectedLabelKey"
        [noItemsSelectedLabelKey]="noItemsSelectedLabelKey"
        [totalPageItemsCount]="totalPageItemsCount"
        [selectedPageItemsCount]="selectedPageItemsCount"
        [selectedItemsCount]="selectedItemsCount"
        [isInitialBulk]="isInitialBulk"
        (selectionChanged)="onSelectionChanged($event)"
    ></sh-context-action-bar>
</div>

<ng-container *ngTemplateOutlet="columns.length === 0 ? gridTemplate : listTemplate"></ng-container>

<ng-template #listTemplate>
    <table class="sh-card-table">
        <thead *ngIf="!hideColumnHeaders" [ngClass]="{ 'sh-card-table__header--context-actions': availableSelect }">
            <tr>
                <th *ngIf="availableDragAndDrop" scope="col" class="sh-card-table__col--draggable-icon"></th>
                <th *ngIf="availableSelect" scope="col" class="sh-card-table__col--small" id="select-all">
                    <ng-container *ngTemplateOutlet="canBatchSelect ? switchSelectAll : defaultSelectAll"></ng-container>
                </th>
                @for (columnDefinition of columns; track columnDefinition.toString(); let columnIndex = $index) {
                    <th scope="col" [style]="'width: ' + columnDefinition.width + 'px'" [ngClass]="{ 'sh-invisible': columnDefinition.headerHidden }">
                        <div class="sh-column-sort">
                            <span>
                                {{ columnDefinition.translateLabel | translate }}
                            </span>
                            @if (allowSort) {
                                <sh-column-sort
                                    [columnDefinition]="columnDefinition"
                                    [currentSort]="currentSort"
                                    (sortInfoChanged)="onSortInfoChanged($event)"
                                ></sh-column-sort>
                            }
                        </div>
                    </th>
                }
                <th *ngIf="availableActionItems" scope="col" class="sh-column-settings sh-sticky-col--end">
                    <span>
                        {{ "generic-overview.table-head.actions" | translate }}
                    </span>
                    @if (columnOptions.length > 0) {
                        <sh-column-selection
                            class="sh-column-settings__action"
                            [columnOptions]="columnOptions"
                            [selectedColumns]="columns"
                            (columnSelectionChanged)="onColumnSelectionChanged($event)"
                        ></sh-column-selection>
                    }
                </th>
            </tr>
        </thead>
        <ng-container *ngTemplateOutlet="content"></ng-container>
    </table>
</ng-template>

<ng-template #gridTemplate>
    <div *ngIf="availableSelect" class="sh-action-bar-wrapper">
        <div class="sh-action-bar">
            <div class="sh-action-bar__group" id="select-all">
                <ng-container *ngTemplateOutlet="canBatchSelect ? switchSelectAll : defaultSelectAll"></ng-container>
            </div>
            <div class="sh-action-bar__group"></div>
        </div>
    </div>
    <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #content>
    <ng-content></ng-content>
</ng-template>

<ng-template #defaultSelectAll>
    <!-- List display -->
    <input
        *ngIf="columns.length > 0"
        type="checkbox"
        id="selection-checkbox"
        [formControl]="defaultSelectControl"
        class="sh-checkbox -sh-vertical-align"
        (change)="onSimpleSelectionChanged()"
    />

    <!-- Grid display -->
    <div class="sh-action-bar__group__item" *ngIf="columns.length === 0">
        <div class="sh-form-check">
            <input
                type="checkbox"
                id="selection-checkbox"
                class="sh-checkbox sh-form-check__input"
                [formControl]="defaultSelectControl"
                (change)="onSimpleSelectionChanged()"
            />
            <label for="selection-checkbox" class="sh-form-check__label">{{ "general.select-all" | translate }}</label>
        </div>
    </div>
</ng-template>

<ng-template #switchSelectAll>
    <sh-form-checkbox-with-dropdown
        type="checkbox"
        [id]="'selection-checkbox'"
        [control]="extendedSelectControl"
        [canBeIndeterminate]="true"
        [inverted]="false"
        [label]="columns.length === 0 ? ('general.select-all' | translate) : ''"
        [options]="actionModes"
    ></sh-form-checkbox-with-dropdown>
</ng-template>
